
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faExternalLinkAlt as fasExternalLinkAlt,
    } from '@fortawesome/pro-solid-svg-icons/faExternalLinkAlt';

    import WhatIsThis from '@/components/Utils/WhatIsThis';
    import { Bus } from '@/utils/bus';

    export default {
        name: 'ApplyFormCustomNotice',

        components: {
            WhatIsThis,
            FontAwesomeIcon,
        },

        data() {
            return {
                icons: {
                    fasExternalLinkAlt,
                },
            };
        },

        methods: {
            apply() {
                Bus.$emit('skipToJob');
            },
        },
    };
